'use strict';

angular.module('amexReconciliationApp')
  .directive('amountSelect',
  function amountSelect() {
    var controller = function amountSelectController($scope) {
      $scope.selectCurrency = function (newCurrency) {
        $scope.monetaryObject.currency = newCurrency;
      };
    };
    return {
      restrict: 'E',
      scope: {
        monetaryObject: '=monetaryObject'
      },
      templateUrl: 'scripts/views/amount-select.html',
      controller: controller
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/amountSelect.js
// module id = 512
// module chunks = 0